window.formStyles = window.formStyles || new Map();

window.formStyles.set('zone2-form-overrides', `
  input,
  textarea,
  button._formFileInputField_ehvsf_5 {
    background: var(--g-input-bg) !important;
    border: 1px solid var(--g-input-border) !important;
    border-radius: 8px !important;
    box-shadow: none !important;
    font-size: 16px !important;
  }

  input:focus-visible,
  textarea:focus-visible,
  button._formFileInputField_ehvsf_5:focus-visible {
    box-shadow: inset 0 0 0 1px #000 !important;
  }

  ._formFieldContainer_1mxsl_5:has(textarea)::before {
    content: none !important;
  }

  button._formFileInputField_ehvsf_5 {
    padding: 0 !important;
    background-color: #f9f9f9 !important;
  }

  ._formFileInputButton_ehvsf_18 {
    background-color: #f9f9f9 !important;
    color: #000 !important;
    font-size: 14px !important;
    line-height: 0 !important;
    padding: 10px 0 !important;
  }

  button._formSubmitButton_cit2d_96 {
    font-weight: 600 !important;
  }

  form._formFieldset_cit2d_82 {
    gap: 1.5rem !important;
    padding: 0 !important;
  }

  div._formDisclaimer_cit2d_38 {
    font-size: 12px !important;
    line-height: 1.5 !important;
  }

  label[id="label-first_name"]::after,
  label[id="label-email"]::after,
  label[id="label-custom#bericht"]::after {
    content: " *";
  }

  ._formContainer_1q1d2_30 {
    margin: 0 !important;
  }

  ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
    width: 100% !important;
    max-width: 600px !important;
  }

  ._inline_1q1d2_47 ._grid_1q1d2_148 {
    max-width: 600px !important;
    grid-template-columns: 1fr !important;
  }

  @media (max-width: 767px) {
    ._gridItemContent_1q1d2_257 {
      padding-left: 20px !important;
      padding-right: 20px !important;
    }
  }
`);